export function BlueprintCard({ index = 0, className = "", style = {}, children, testId }) {
  const delay = `${index * 0.3}s`;
  return (
    <div
      className={`bp panel-card ${className}`}
      data-testid={testId}
      style={{ ...style, "--d": delay }}
    >
      <span className="seg top" />
      <span className="seg right" />
      <span className="seg bottom" />
      <span className="seg left" />
      <div className="bp-content">{children}</div>
    </div>
  );
}
